// zusätzlich das Login-JS nachladen

function mpLoadLang() {
    $.cachedScript($('#mpMainScript').attr('src').replace('mp.js', 'i18n/' + mpData.currentLang + '.js'));
}

if (mpModule === 'Login') {
    $.cachedScript($('#mpMainScript').attr('src').replace('mp.js', 'mplogin.js')).done(function () {
        mpLoadLang();
    });
} else if (mpModule === 'Manager') {
    $.cachedScript($('#mpMainScript').attr('src').replace('mp.js', 'mpmanager.js')).done(function () {
        mpLoadLang();
    });
} else {
    mpLoadLang();
}